import React, { useState } from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Typography,
  Popover,
  Stack,
  alpha,
  useTheme,
} from "@mui/material";
import { KeyboardArrowDown, UploadFile } from "@mui/icons-material";

// Senin zaten hazır olan ve arka planda tüm dosya/API işini halleden componentlerini çağırıyoruz
import LabUploadButton from "./LabUploadButton";
import SondaLabUploadButton from "./SondaLabUploadButton";

export default function CombinedLabUploadWrapper({ jobId, onUploadSuccess }) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  // Çocuk component'ler (LabUploadButton vs.) başarılı olduğunda hem tabloyu günceller hem de popup'ı kapatır
  const handleSuccess = () => {
    if (onUploadSuccess) onUploadSuccess();
    handleClose();
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <Tooltip title="Laboratuvar Verisi Yükle (Profil & Sonda)">
        <IconButton
          color="primary"
          onClick={handleClick}
          sx={{
            bgcolor: alpha(theme.palette.primary.main, 0.05),
            mb: 0.5,
            "&:hover": { bgcolor: alpha(theme.palette.primary.main, 0.15) },
          }}
        >
          <UploadFile fontSize="small" />
        </IconButton>
      </Tooltip>
      <Typography
        variant="caption"
        sx={{
          fontSize: "0.6rem",
          color: "text.secondary",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
        }}
      >
        LAB YÜKLE <KeyboardArrowDown sx={{ fontSize: "0.8rem" }} />
      </Typography>

      {/* Tıklanınca açılan ve hazır componentlerini gösteren pencere */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        PaperProps={{ sx: { p: 2, mt: 1, borderRadius: 3, boxShadow: 4 } }}
      >
        <Typography
          variant="caption"
          sx={{
            display: "block",
            textAlign: "center",
            mb: 2,
            color: "text.secondary",
            fontWeight: "bold",
          }}
        >
          YÜKLENECEK VERİ TİPİNİ SEÇİN
        </Typography>
        <Stack
          direction="row"
          spacing={3}
          alignItems="center"
          justifyContent="center"
        >
          {/* PROFİL LAB YÜKLEME (Hazır Component) */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <LabUploadButton jobId={jobId} onUploadSuccess={handleSuccess} />
            <Typography
              variant="caption"
              sx={{
                fontSize: "0.6rem",
                color: "text.secondary",
                mt: 0.5,
                fontWeight: "bold",
              }}
            >
              P LAB YÜKLE
            </Typography>
          </Box>

          {/* SONDA LAB YÜKLEME (Hazır Component) */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <SondaLabUploadButton
              jobId={jobId}
              onUploadSuccess={handleSuccess}
            />
            <Typography
              variant="caption"
              sx={{
                fontSize: "0.6rem",
                color: "text.secondary",
                mt: 0.5,
                fontWeight: "bold",
              }}
            >
              S LAB YÜKLE
            </Typography>
          </Box>
        </Stack>
      </Popover>
    </Box>
  );
}
